import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../store/actions/index";
import _ from "lodash";
import moment from "moment";

import { SearchOutlined } from "@ant-design/icons";

import { Table, Input, Button, Tag, Popconfirm } from "antd";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../components/Breadcrumb";

import ExportCSV from "../components/Common/ExportCSV";

// const data = this.props.api.userGetData;

class Hotel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      searchedColumn: "",
      loading: false,
      visible: false,
      createModalVisible: false,
      updateModalVisible: false,
      updateInitialValue: null,
      exportData: null,
    };
    this.hotelDataAvailable = true;
  }

  async componentDidMount() {
    // if (!this.props.api.hmgGetData) {
    //   await this.props.hmgGet();
    // }
    // if (!this.props.api.pmsGetData) {
    //   await this.props.pmsGet();
    // }
    if (!this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
    this.setState({
      exportData: this.props.api.hotelGetData.data,
    });
  }

  componentDidUpdate() {
    this.hotelDataAvailable = true;
  }

  getColumnSearchProps = (dataIndex, type, isSearchIndexs) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (type == "array") {
        if (record[dataIndex]) {
          let rValue = false;
          record[dataIndex].forEach((d) => {
            if (d.toString().toLowerCase().includes(value.toLowerCase())) {
              rValue = true;
            }
          });
          return rValue;
          // return record.hotels.hotel_name.toString().toLowerCase().includes(value.toLowerCase())
        } else {
          return false;
        }
      } else if (type == "multiple") {
        if (record[dataIndex]) {
          var rValue = false;
          isSearchIndexs.forEach((element) => {
            if (
              record[element] &&
              record[element]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            ) {
              rValue = true;
            }
          });
          return rValue;
        } else {
          return false;
        }
      } else {
        if (record[dataIndex]) {
          return record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        } else {
          return false;
        }
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  createModalShow = () => {
    this.setState({ createModalVisible: true });
  };

  createModalCancel = () => {
    this.setState({ createModalVisible: false });
  };

  createModalCreate = () => {
    const { form } = this.createModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hotelCreate(values)) {
        form.resetFields();
        await this.props.hotelGet();
        this.setState({ createModalVisible: false });
      }
    });
  };

  createModalFormRefSaveFormRef = (formRef) => {
    this.createModalFormRef = formRef;
  };

  handleEdit = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalShow = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalCancel = () => {
    const { form } = this.updateModalFormRef.props;
    form.resetFields();
    this.setState({ updateModalVisible: false, updateInitialValue: null });
  };

  updateModalCreate = () => {
    const { form } = this.updateModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hotelUpdate(values)) {
        form.resetFields();
        await this.props.hotelGet();
        this.setState({ updateModalVisible: false });
      }
    });
  };

  updateModalFormRefSaveFormRef = (formRef) => {
    this.updateModalFormRef = formRef;
  };

  hotelDelete = async (value) => {
    if (await this.props.deleteItem({ type: "hotel", _id: value })) {
      await this.props.hotelGet();
    }
  };
  getUpdatedExcelBuffer = (hotelMgr) => {
    return _.cloneDeep(hotelMgr).map((i) => {
      if (i.sign_type != undefined) {
        if (i.sign_type == 2) {
          i.sign_type = "Docusign";
        } else if (i.sign_type == 3) {
          i.sign_type = "PandaDoc";
        } else {
          i.sign_type = "None";
        }
      }
      i.create_at = i.create_at
        ? moment(i.create_at).local().format("YYYY-MM-DD HH:mm:ss")
        : null;
      i.update_at = i.update_at
        ? moment(i.update_at).local().format("YYYY-MM-DD HH:mm:ss")
        : null;
      return i;
    });
  };

  render() {
    let columns = [
      {
        title: "Hotel Code",
        dataIndex: "hotel_code",
        key: "hotel_code",
        fixed: "left",
        width: "200px",
        ...this.getColumnSearchProps("hotel_code"),
        sorter: (a, b) =>
          a.hotel_code ? a.hotel_code.localeCompare(b.hotel_code) : null,
      },
      {
        title: "Hotel Name",
        dataIndex: "hotel_name",
        key: "hotel_name",

        width: "250px",

        ...this.getColumnSearchProps("hotel_name"),
        sorter: (a, b) =>
          a.hotel_name ? a.hotel_name.localeCompare(b.hotel_name) : null,
      },
      {
        title: "IS Hotel Name",
        dataIndex: "is_hotel_name",
        key: "is_hotel_name",

        width: "250px",

        ...this.getColumnSearchProps("is_hotel_name"),
        sorter: (a, b) =>
          a.is_hotel_name
            ? a.is_hotel_name.localeCompare(b.is_hotel_name)
            : null,
      },
      {
        title: "MYP Hotel Name",
        dataIndex: "myp_hotel_name",
        key: "myp_hotel_name",

        width: "250px",

        ...this.getColumnSearchProps("myp_hotel_name"),
        sorter: (a, b) =>
          a.myp_hotel_name
            ? a.myp_hotel_name.localeCompare(b.myp_hotel_name)
            : null,
      },

      {
        title: "ID",
        dataIndex: "_id",
        key: "_id",
        width: "250px",
        ...this.getColumnSearchProps("_id"),
      },
      {
        title: "Primary HMG - Project",
        dataIndex: "primary_hmg_name",
        key: "primary_hmg_name",
        width: "500px",

        ...this.getColumnSearchProps("primary_hmg_name", "multiple", [
          "primary_hmg_name",
          "primary_hmg_project_name",
        ]),
        sorter: (a, b) =>
          a.primary_hmg_name
            ? a.primary_hmg_name.localeCompare(b.primary_hmg_name)
            : null,
        render: (text, record) => (
          <span>
            {text} - {record.primary_hmg_project_name}
          </span>
        ),
      },
      {
        title: "Secondary HMG - Project",
        dataIndex: "secondary_hmg_name",
        key: "secondary_hmg_name",
        width: "400px",
        ...this.getColumnSearchProps("secondary_hmg_name", "multiple", [
          "secondary_hmg_name",
          "secondary_hmg_project_name",
        ]),
        sorter: (a, b) =>
          a.secondary_hmg_name
            ? a.secondary_hmg_name.localeCompare(b.secondary_hmg_name)
            : null,
        render: (text, record) =>
          text ? (
            <span>
              {text} - {record.secondary_hmg_project_name}
            </span>
          ) : null,
      },
      {
        title: "Third HMG - Project",
        dataIndex: "third_hmg_name",
        key: "third_hmg_name",
        width: "400px",
        ...this.getColumnSearchProps("third_hmg_name", "multiple", [
          "third_hmg_name",
          "third_hmg_project_name",
        ]),
        sorter: (a, b) =>
          a.third_hmg_name
            ? a.third_hmg_name.localeCompare(b.third_hmg_name)
            : null,
        render: (text, record) =>
          text ? (
            <span>
              {text} - {record.third_hmg_project_name}
            </span>
          ) : null,
      },
      {
        title: "Fourth HMG - Project",
        dataIndex: "fourth_hmg_name",
        key: "fourth_hmg_name",
        width: "400px",
        ...this.getColumnSearchProps("fourth_hmg_name", "multiple", [
          "fourth_hmg_name",
          "fourth_hmg_project_name",
        ]),
        sorter: (a, b) =>
          a.fourth_hmg_name
            ? a.fourth_hmg_name.localeCompare(b.fourth_hmg_name)
            : null,
        render: (text, record) =>
          text ? (
            <span>
              {text} - {record.fourth_hmg_project_name}
            </span>
          ) : null,
      },
      {
        title: "Rooms",
        dataIndex: "rooms",
        key: "rooms",
        width: "100px",
        ...this.getColumnSearchProps("rooms"),
      },
      {
        title: "Hours Of Operation",
        dataIndex: "hours_of_operation",
        key: "hours_of_operation",
        width: "200px",
        ...this.getColumnSearchProps("hours_of_operation"),
      },
      {
        title: "File Location",
        dataIndex: "file_location",
        key: "file_location",
        width: "200px",
        ...this.getColumnSearchProps("file_location"),
      },
      {
        title: "Time Zone",
        dataIndex: "time_zone",
        key: "time_zone",
        width: "150px",
        ...this.getColumnSearchProps("time_zone"),
      },
      {
        title: "PMS",
        dataIndex: "pms_name",
        key: "pms_name",
        width: "250px",
        ...this.getColumnSearchProps("pms_name", "array", ["pms_name"]),
        render: (tags) => (
          <span>
            {tags.map((tag) => (
              <Tag
                color="blue"
                key={tag}
                style={{ marginRight: "2px", marginBottom: "2px" }}
              >
                {tag}
              </Tag>
            ))}
          </span>
        ),
      },
      {
        title: "Pending PMS Changes",
        dataIndex: "pending_pms_changes",
        key: "pending_pms_changes",
        width: "250px",
        ...this.getColumnSearchProps("pending_pms_changes"),
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        width: "300px",
        ...this.getColumnSearchProps("description"),
      },
      {
        title: "Additional PMS",
        dataIndex: "additional_pms",
        key: "additional_pms",
        width: "200px",
        ...this.getColumnSearchProps("additional_pms"),
      },
      {
        title: "Pms Native Name",
        dataIndex: "pms_native_name",
        key: "pms_native_name",
        width: "200px",
        ...this.getColumnSearchProps("pms_native_name"),
      },
      {
        title: "Hotel Phone Number",
        dataIndex: "hotel_phone_number",
        key: "hotel_phone_number",
        width: "200px",
        ...this.getColumnSearchProps("hotel_phone_number"),
      },
      {
        title: "Hotel Address",
        dataIndex: "hotel_address",
        key: "hotel_address",
        width: "200px",
        ...this.getColumnSearchProps("hotel_address"),
      },
      {
        title: "Hotel City",
        dataIndex: "hotel_city",
        key: "hotel_city",
        width: "200px",
        ...this.getColumnSearchProps("hotel_city"),
      },
      {
        title: "Hotel State",
        dataIndex: "hotel_state",
        key: "hotel_state",
        width: "200px",
        ...this.getColumnSearchProps("hotel_state"),
      },
      {
        title: "Hotel Country",
        dataIndex: "hotel_country",
        key: "hotel_country",
        width: "200px",
        ...this.getColumnSearchProps("hotel_country"),
      },
      {
        title: "Unit Num",
        dataIndex: "unit_num",
        key: "unit_num",
        width: "200px",
        ...this.getColumnSearchProps("unit_num"),
      },
      {
        title: "Primary Contact",
        dataIndex: "primary_contact",
        key: "primary_contact",
        width: "200px",
        ...this.getColumnSearchProps("primary_contact"),
      },
      {
        title: "General Manager",
        dataIndex: "general_manager",
        key: "general_manager",
        width: "200px",
        ...this.getColumnSearchProps("general_manager"),
      },
      {
        title: "GM Email",
        dataIndex: "gm_email",
        key: "gm_email",
        width: "200px",
        ...this.getColumnSearchProps("gm_email"),
      },
      {
        title: "GM Phone",
        dataIndex: "gm_phone",
        key: "gm_phone",
        width: "200px",
        ...this.getColumnSearchProps("gm_phone"),
      },
      {
        title: "GM Contact Hours From",
        dataIndex: "gm_contact_hours_from",
        key: "gm_contact_hours_from",
        width: "220px",
        ...this.getColumnSearchProps("gm_contact_hours_from"),
      },
      {
        title: "GM Contact Hours To",
        dataIndex: "gm_contact_hours_to",
        key: "gm_contact_hours_to",
        width: "200px",
        ...this.getColumnSearchProps("gm_contact_hours_to"),
      },
      {
        title: "Position Title",
        dataIndex: "position_title",
        key: "position_title",
        width: "200px",
        ...this.getColumnSearchProps("position_title"),
      },
      {
        title: "Report Set UpDate",
        dataIndex: "report_set_up_date",
        key: "report_set_up_date",
        width: "200px",
        ...this.getColumnSearchProps("report_set_up_date"),
      },
      {
        title: "Signature Go Live Date",
        dataIndex: "signature_go_live_date",
        key: "signature_go_live_date",
        width: "200px",
        ...this.getColumnSearchProps("signature_go_live_date"),
      },
      {
        title: "Go Live Date",
        dataIndex: "go_live_date",
        key: "go_live_date",
        width: "200px",
        ...this.getColumnSearchProps("go_live_date"),
      },
      {
        title: "QC Cutoff",
        dataIndex: "qc_cutoff",
        key: "qc_cutoff",
        width: "200px",
        ...this.getColumnSearchProps("qc_cutoff"),
      },
      {
        title: "Sign Type",
        dataIndex: "sign_type",
        key: "sign_type",
        width: "200px",
        render: (data) => {
          if (data == 3) {
            return "PandaDoc";
          }
          if (data == 2) {
            return "Docusign";
          }
          if (data == 1) {
            return "None";
          }
        },
        sorter: (a, b) =>
          a.sign_type ? a.sign_type.localeCompare(b.sign_type) : null,
      },
      {
        title: "Enable Triggers",
        dataIndex: "enable_triggers_name",
        key: "enable_triggers_name",
        width: "200px",
        render: (text) => {
          if (text == "Disable") {
            return <Tag color="red">{text}</Tag>;
          }
          if (text == "Enable") {
            return <Tag color="blue">{text}</Tag>;
          }
        },
        sorter: (a, b) =>
          a.enable_triggers_name
            ? a.enable_triggers_name.localeCompare(b.enable_triggers_name)
            : null,
      },
      {
        title: "Historical Data",
        dataIndex: "historical_data_name",
        key: "historical_data_name",
        width: "200px",
        render: (text) => {
          if (text == "Disable") {
            return <Tag color="red">{text}</Tag>;
          }
          if (text == "Enable") {
            return <Tag color="blue">{text}</Tag>;
          }
        },
        sorter: (a, b) =>
          a.historical_data_name
            ? a.historical_data_name.localeCompare(b.historical_data_name)
            : null,
      },
      {
        title: "Serverless Migration",
        dataIndex: "serverless_hotel",
        key: "serverless_hotel",
        width: "200px",
        render: (text) => {
          if (text == false) {
            return <Tag color="red">Disable</Tag>;
          }
          if (text == true) {
            return <Tag color="blue">Enable</Tag>;
          }
        },
        sorter: (a, b) =>
          a.serverless_hotel
            ? (a.serverless_hotel ? "true" : "false").localeCompare(
                b.serverless_hotel ? "true" : "false",
              )
            : "false",
      },
      {
        title: "Live in S3",
        dataIndex: "live_in_s3_name",
        key: "live_in_s3_name",
        width: "200px",
        render: (text) => {
          if (text == "Disable") {
            return <Tag color="red">{text}</Tag>;
          }
          if (text == "Enable") {
            return <Tag color="blue">{text}</Tag>;
          }
        },
        sorter: (a, b) =>
          a.live_in_s3_name
            ? a.live_in_s3_name.localeCompare(b.live_in_s3_name)
            : null,
      },
      {
        title: "Hotel Status",
        dataIndex: "hotel_status",
        key: "hotel_status",
        width: "200px",
        ...this.getColumnSearchProps("hotel_status"),
      },
      {
        title: "QC Hotel ID",
        dataIndex: "qc_hotel_id",
        key: "qc_hotel_id",
        width: "200px",
        ...this.getColumnSearchProps("qc_hotel_id"),
        sorter: (a, b) => {
          a = a.qc_hotel_id || 0;
          b = b.qc_hotel_id || 0;
          return a - b;
        },
      },
      {
        title: "MYP Hotel ID",
        dataIndex: "myp_id",
        key: "myp_id",
        width: "200px",
        ...this.getColumnSearchProps("myp_id"),
        sorter: (a, b) => {
          a = a.myp_id || 0;
          b = b.myp_id || 0;
          return a - b;
        },
      },
      {
        title: "AdHoc Reports Schedule",
        dataIndex: "adhoc_reports_schedule",
        key: "adhoc_reports_schedule",
        width: "220px",
        ...this.getColumnSearchProps("adhoc_reports_schedule"),
      },
      {
        title: "SS3U Hotel Mapping Name",
        dataIndex: "ss3u_hotel_mapping_name",
        key: "ss3u_hotel_mapping_name",
        width: "380px",
        ...this.getColumnSearchProps("ss3u_hotel_mapping_name"),
        sorter: (a, b) => {
          a = a.ss3u_hotel_mapping_name || "";
          b = b.ss3u_hotel_mapping_name || "";
          return a.localeCompare(b);
        },
      },
      {
        title: "IntelliSight Plus",
        dataIndex: "intellisight_plus",
        key: "intellisight_plus",
        width: "200px",
        render: (text) => {
          if (text) {
            return <Tag color="red">True</Tag>;
          }
          return <Tag color="blue">False</Tag>;
        },
        sorter: (a, b) => {
          a = a?.intellisight_plus ? "true" : "false";
          b = b?.intellisight_plus ? "true" : "false";
          return a.localeCompare(b);
        },
      },
      {
        title: "MDO Hotel Email",
        dataIndex: "mdo_hotel_email",
        key: "mdo_hotel_email",
        width: "340px",
        ...this.getColumnSearchProps("mdo_hotel_email"),
      },
      {
        title: "Facebook Page Url",
        dataIndex: "facebook_page_url",
        key: "facebook_page_url",
        width: "200px",
        ...this.getColumnSearchProps("facebook_page_url"),
      },
      {
        title: "Google PlaceId",
        dataIndex: "google_place_id",
        key: "google_place_id",
        width: "200px",
        ...this.getColumnSearchProps("google_place_id"),
      },
      {
        title: "Tripadvisor Location Id",
        dataIndex: "tripAdvisor_location_id",
        key: "tripAdvisor_location_id",
        width: "200px",
        ...this.getColumnSearchProps("tripAdvisor_location_id"),
      },
      {
        title: "Yelp BusinessId",
        dataIndex: "yelp_business_id",
        key: "yelp_business_id",
        width: "200px",
        ...this.getColumnSearchProps("yelp_business_id"),
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        ...this.getColumnSearchProps("create_by"),
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        ...this.getColumnSearchProps("create_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        ...this.getColumnSearchProps("update_by"),
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        ...this.getColumnSearchProps("update_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   fixed: "right",
      //   width: "100px",
      //   render: (text, record) => (
      //     <Popconfirm
      //       title="Sure to edit?"
      //       onConfirm={() => this.updateModalShow(record)}
      //     >
      //       <a href="/#">Edit</a>
      //     </Popconfirm>
      //   )
      // }
    ];

    if (this.props.api.permission.sm_hotel_delete) {
      columns.push({
        title: "Action",
        dataIndex: "action",
        // fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => this.hotelDelete(record._id)}
          >
            <Button
              type="default"
              danger
              size="small"
              style={{ paddingLeft: "5px", paddingRight: "5px" }}
            >
              Delete
            </Button>
          </Popconfirm>
        ),
      });
    }

    let tableHeight = 500;
    if (window.innerWidth > 700) {
      tableHeight = window.innerHeight - 300;
    }

    return (
      <div>
        <div className="container_aa">
          <h3>Hotel Manager</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              { path: "hotel-manager", breadcrumbName: "Hotel Manager" },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1 user_manager">
            {/* <div className="container_style_1_a">
              <Button type="primary" onClick={this.createModalShow}>
                Create Hotel
              </Button>
            </div> */}
            <div className="container_style_1_b">
              {this.state.exportData ? (
                <div className="is_table_3 a01">
                  <ExportCSV
                    csvData={this.getUpdatedExcelBuffer(this.state.exportData)}
                    fileName={"HotelManager"}
                    columnNames={columns}
                  />
                  <Table
                    className={"sm-custom-column-header"}
                    columns={columns}
                    scroll={{ x: 12000, y: tableHeight }}
                    dataSource={this.props.api.hotelGetData.data}
                    rowKey="_id"
                    onChange={(_e, _f, _g, h) => {
                      this.hotelDataAvailable = false;
                      this.setState({
                        exportData: h.currentDataSource,
                      });
                    }}
                  />
                </div>
              ) : null}
              {/* {this.props.api.hmgGetData && this.props.api.pmsGetData ? (
                <CreateForm
                  wrappedComponentRef={this.createModalFormRefSaveFormRef}
                  visible={this.state.createModalVisible}
                  onCancel={this.createModalCancel}
                  onCreate={this.createModalCreate}
                  hmgGetData={this.props.api.hmgGetData.data}
                  pmsGetData={this.props.api.pmsGetData.data}
                />
              ) : null} */}
              {/* {this.props.api.hmgGetData && this.props.api.pmsGetData ? (
                <UpdateForm
                  wrappedComponentRef={this.updateModalFormRefSaveFormRef}
                  visible={this.state.updateModalVisible}
                  onCancel={this.updateModalCancel}
                  onCreate={this.updateModalCreate}
                  updateInitialValue={this.state.updateInitialValue}
                  hmgGetData={this.props.api.hmgGetData.data}
                  pmsGetData={this.props.api.pmsGetData.data}
                />
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  pmsGet: () => dispatch(actions.pmsGet()),
  hotelGet: () => dispatch(actions.hotelGet()),
  hotelCreate: (data) => dispatch(actions.hotelCreate(data)),
  hotelUpdate: (data) => dispatch(actions.hotelUpdate(data)),
  deleteItem: (data) => dispatch(actions.deleteItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hotel);
